import {resolveIdentifier, types} from 'mobx-state-tree'
import {ExtendedDataSetModel} from "../../models/extendedData/ExtendedDataSet";
import ExtendedDataSetStore from "../../stores/domain/ExtendedDataSetStore";
import {Utm} from "../../models/utms/UtmModel";
import lodash from "lodash";

export const ExtendedDataSetSelectState = types.model("ExtendedDataSetSelectState",{
  selectStateUuid: types.identifier,
  store: types.maybe(types.late(() => types.reference(ExtendedDataSetStore))),
  selected: types.safeReference(ExtendedDataSetModel),
  selectedExtendedDataSets: types.optional(types.array(types.safeReference(ExtendedDataSetModel)), []),
}).volatile(self => ({
  notifySelect: types.function
})).actions( (self)=>({
  selectExtendedDataSet(arr){
    self.notifySelect(arr);
  },
  setConsumer(f){
    self.notifySelect = f;
  },
  select(extendedDataSet) {
    if(extendedDataSet && extendedDataSet.uuid) {
      self.notifySelect(extendedDataSet)
      self.selected = resolveIdentifier(ExtendedDataSetModel, self, extendedDataSet.uuid || extendedDataSet)
    }
    else{
      self.selected=undefined
    }
  },
  setSelectedExtendedData(arr) {
    if(lodash.isArray(arr)) {
      const result = [];
      arr?.forEach((set) => {
        result.push(resolveIdentifier(ExtendedDataSetModel, self, set?.uuid || set));
      });
      self.selectedExtendedDataSets = result;
    }
    else{
      if(arr && arr.uuid) {
        self.selected = resolveIdentifier(ExtendedDataSetModel, self, arr.uuid || arr)
        self.selectedExtendedDataSets  = [self.selected]
      }
      else{
        self.selected=undefined
        self.selectedExtendedDataSets  = undefined
      }
    }
  },
})).views( (self) => ({
  getSelectedExtendedDataSets() {
    return self.selectedExtendedDataSets?.filter(n => n);
  },
  getSelectedExtendedData() {
    return self.selectedExtendedDataSets?.flatMap(s => s.extendedData);
  },
  optionValues() {
    return self?.store?.getExtendedDataSetList() || [];
  },
}));
